import { useGlobalState, useStatsigLayer } from '@/hooks';
import { useMyParcelsContext } from '@/modules/pmt/context';

export const useMyParcelsRightSectionCopy = () => {
  const { isLoggedIn } = useGlobalState();
  const { trackingTranslation } = useMyParcelsContext();
  const { getEnglishOnlyText: getAnonymousEnglishOnlyText, isReady: isAnonymousReady } =
    useStatsigLayer('track_my_parcel_copy_layer');
  const { getEnglishOnlyText: getSignedInEnglishOnlyText, isReady: isSignedInReady } = useStatsigLayer(
    'track_my_parcel_signed_in_layer',
  );

  const fallback = {
    sectionTitleDesktop: trackingTranslation.sectionTitleDesktop ?? '',
  };

  if (!isAnonymousReady || !isSignedInReady) return fallback;

  const getEnglishOnlyText = isLoggedIn ? getSignedInEnglishOnlyText : getAnonymousEnglishOnlyText;

  return {
    sectionTitleDesktop: getEnglishOnlyText('section_title_desktop', fallback.sectionTitleDesktop),
  };
};
